import type { FC } from "react";
import { EmptyStateCard } from "@/components/podkit/EmptyStateCard";
import { IconPlus } from "@/assets/icons/geist/IconPlus";
import { Button } from "@/components/flexkit/Button";
import { Link } from "react-router-dom";
import { AutomationStepList } from "@/components/automations/AutomationStepList";
import { StepListContainer } from "@/routes/automations/automation-details-page/StepListContainer";
import type { WorkflowEditFormStepData } from "@/components/automations/automation-edit-form-data";
import { workflowDetailsEditUrl } from "@/utils/automations";

export const AutomationDefinitionSectionView: FC<{ workflowId: string; steps: WorkflowEditFormStepData[] }> = ({
    workflowId,
    steps,
}) => {
    if (steps.length === 0) {
        return (
            <EmptyStateCard
                title="Define your automation"
                description="Begin by describing what should happen when this automation is run."
                data-testid="workflow-executions-empty-state"
            >
                <Button asChild variant="primary" LeadingIcon={IconPlus} data-tracking-id="run-workflow-empty-state">
                    <Link to={workflowDetailsEditUrl({ id: workflowId })}>Add Step</Link>
                </Button>
            </EmptyStateCard>
        );
    }

    return (
        <StepListContainer>
            <div className="flex w-full max-w-screen-xl flex-row items-start justify-center gap-4">
                <AutomationStepList steps={steps} />
            </div>
        </StepListContainer>
    );
};
